// extracted by mini-css-extract-plugin
export default {"plusIcon":"ImportCsv_plusIcon__2Ey0I"};